


































































import { Component, Vue, Prop, Watch } from "@/shared/vuepack";
import moment from "moment/moment";
import { Validator } from "vee-validate";
import {
  PartnerAssociation,
  ResourceFormDocument,
  ResourceFormDocumentBase,
  ResourceFormPlanType,
  FormDocumentType,
  Permission
} from "@/shared/types";
import ResourceFormRow from "@/employer/components/Forms/ResourceFormRow.vue";
import ResourceFormCreate from "@/employer/components/Forms/ResourceFormCreate.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useResourceFormStore } from "@/employer/store/ResourceForm";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";

@Component({
  components: {
    GenericLoadingSpinner,
    ResourceFormRow,
    ResourceFormCreate
  }
})
export default class ResourceForms extends Vue {
  rolePermissionsStore = useRolePermissionsStore();
  userStore = useUserStore();
  resourceFormStore = useResourceFormStore();
  notifierStore = useNotifierStore();


  @Prop()
  partnerId: number;
  partnerLoaded = false;

  $validator: Validator;
  isSubmitting = false;
  showAddForm = false;
  model = null;

  get dataLoaded () {
    return this.partnerLoaded;
  }

  get disabledCreateButton () {
    return this.isSubmitting || !this.hasWidgetWritePermission;
  }

  @Watch("resourceFormStore.fetchStates")
  onPartnerLoadedChanged (oldVal, newVal) {
    if (this.partnerLoaded === false) {
      if (this.resourceFormStore.isPartnerLoaded(this.partnerId)) {
        this.partnerLoaded = true;
        this.model = this.createDefaultModel();
      }
    }
  }

  get hasWidgetWritePermission () {
    return this.rolePermissionsStore.userHasPartnerPermission(Permission.PartnerManageFormDocuments, this.partnerId);
  }

  get isSellingPartner () {
    return this.resourceFormStore.isPartnerASellingPartner(this.partnerId);
  }
  get canCreateNewFormDocuments () {
    return this.isSellingPartner || this.resourceFormStore.isPartnerAnAdminPartner(this.partnerId);
  }

  get resourceFormsForCurrentPartner () {
    return this.resourceFormStore.getResourceFormsByPartner(this.partnerId);
  }

  mounted () {
    if (this.partnerId !== this.userStore.currentPartner.partnerId) {
      this.partnerId = this.userStore.currentPartner.partnerId;
    }

    this.resourceFormStore.loadResourceFormsForPartner(this.partnerId).then(
      () => {
        this.model = this.createDefaultModel();
        this.partnerLoaded = true;
      }
    );

  }

  createDefaultModel (): ResourceFormDocument {
    return {
      formDocumentId: 0,
      displayName: "",
      downloadUrl: "",
      dateAvailableStart: moment().toString(),
      dateAvailableEnd: "",
      formDocumentType: FormDocumentType.Document,
      planTypes: [ResourceFormPlanType.HealthSavingAccount],
      sellingPartnerIds: [],
      employers: [],
      isActive: false,
      canOptOut: false,
      isOptedOut: false,
      associations: []
    };
  }

  onAddFormButtonClicked () {
    this.showAddForm = !this.showAddForm;
  }

  onCancel () {
    this.model = this.createDefaultModel();
    this.showAddForm = false;
  }

  onCreate (savedResourceForm: ResourceFormDocumentBase) {
    this.isSubmitting = true;
    this.resourceFormStore.saveResourceForm({ partnerId: this.partnerId, resourceForm: savedResourceForm })
      .then(
        _ => {
          this.isSubmitting = false;
          this.showAddForm = false;
          this.model = this.createDefaultModel();
          this.notifierStore.setSuccess("Form Document Created");
        }
      )
      .catch(
        err => {
          this.isSubmitting = false;
          this.notifierStore.setDanger("Failed to create form document, please try again.");
        }
      );
  }
}
